import { useLocation } from "react-router-dom";
import { ROUTES } from "@/constants/routes";

interface HeroAnimationState {
  showHeader: boolean;
  showHeroContent: boolean;
  showPageContent: boolean;
}

/**
 * Hook to manage hero animation timing for home page
 *
 * Animation timeline:
 * - All content loads immediately (delays removed)
 */
export function useHeroAnimation(): HeroAnimationState {
  // Location used for future extensibility
  const _location = useLocation();
  const _isHomePage = _location.pathname === ROUTES.HOME;

  // Immediately show all content - no delays
  return {
    showHeader: true,
    showHeroContent: true,
    showPageContent: true,
  };
}
